import { Selector } from '@ngxs/store';
import { IRequest } from 'ngxs-requests-plugin';

import { REQUESTS } from './ngxs.module';

export class RequestsGetterState {
  @Selector([
    ...REQUESTS
  ])
  static getIsLoadingRequest(...requests: IRequest[]) {
    return !!requests.find(({loading}) => loading);
  }
}
